export default {
	termsAndConditions: {
		lastUpdate: 'Последње ажурирање: 10. јуна 2024',
		content: `
		<p>Услови које ћете наћи у наставку су важни због:</p>
		<ul>
			<li>Они успостављају своја законска права на {siteName}.</li>
			<li>Објашњавају права која нам дајете када користите {siteName}.</li>
			<li>
				Они описују правила која свако мора да поштује када користи {siteName}.
			</li>
		</ul>
		<p>
			Пажљиво прочитајте ове Услове, као и нашу {privacyPolicyLink} и све друге
			документа поменута у овим Условима.
		</p>
		<p>Хајде да почнемо...</p>
		<h3>1. УВОД И ПОДАЦИ О {siteNameUpper}.</h3>
		<p>
			Веб сајт {websiteLink} (у даљем тексту „Веб сајт“) је у власништву компаније
			{siteName} S.L (у даљем тексту „{siteName}“), компанија
			основана у складу са шпанским законодавством са адресом на Авенида де
			Сердањола, nº 75, 1º, Сант Цугат дел Валлес (Барселона), носилац CIF броја
			B-56.768.260 и регистрован у Трговачком регистру Барселоне у том
			49065, Фолија 0033, Лист B-606324, 1. регистрација.
		</p>
		<p>
			{siteName} вам ставља веб локацију на располагање тако да можете да дођете до ње
			упознајте нас боље, упознајте услуге које пружамо и ако желите, можете нас контактирати
			и, где је прикладно, уговорите са нама.
		</p>

		<h3>2. СВРХА И ОБИМ ПРИМЕНЕ УСЛОВА КОРИШЋЕЊА</h3>
		<p>
			Ови услови коришћења заједно са {privacyPolicyLink} и
			{cookiesPolicyLink}, правни оквир који регулише коришћење веб странице
			{websiteLink}. Ови услови коришћења биће вам доступни на веб страници
			на енглеском тако да их можете консултовати, архивирати или одштампати у било ком тренутку и
			када год хођеш.
		</p>
		<p>
			Да бисте сазнали било које питање у вези са третманом који спроводи {siteName}
			ваших личних података, посетите наше {privacyPolicyLink} и {cookiesPolicyLink}.
			Обе политике ће вам такође бити доступне на енглеском тако да можете
			консултовати их, архивирати или одштампати у било ком тренутку.<br />
			{siteName} користи колачиће треће стране на веб локацији. Да сазнате више
			о врсти колачића који се користе на вебу {websiteLink}, њиховој сврси и како
			да конфигуришете свој претраживач у случају да не желите да користимо ове колачиће,
			посетите наш {cookiesPolicyLink}.
		</p>
		<p>
			Оба ова услова коришћења, као и {privacyPolicyLink} и 
			{cookiesPolicyLink} су припремљени у складу са одредбама важећег
			важећи прописи, између осталих, Закон 34/2002, о услугама
			Информационо друштво и електронска трговина и Уредба (ЕУ) 2016/679 од
			Европског парламента и Савета, од 27. априла 2016. године, у вези са
			заштите физичких лица у погледу обраде личних
			података и слободног кружења ових података и којим Директива 95/46/ЦЕ
			се укида.
		</p>
		<h3>3. ПРИСТУП ВЕБ САЈТУ И ПРИХВАЋАЊЕ</h3>
		<p>
			Приступ веб локацији је бесплатан осим дела који се односи на цену
			везу преко телекомуникационе мреже коју обезбеђује Интернет
			провајдера приступа са којим сте уговорили. Можете слободно да претражујете веб локацију
			и приступите му колико год пута желите. Да бисте приступили веб локацији и кретали се по њој,
			не морате да се региструјете, осим ако желите да ангажујете услугу.
		</p>
		<p>
			Коришћење веб странице вам даје услове корисника веб странице
			(у даљем тексту „Корисник“) и подразумева ваше потпуно и безрезервно прихватање
			ове услове коришћења, као и {privacyPolicyLink} и {cookiesPolicyLink}
			веб странице. Штавише, сагласни сте да нећете користити услугу противзаконито
			сврхе.
		</p>
		<p>
			Приступањем Веб-сајту и његовим прегледањем, изјављујете под својим
			одговорност да сте пунолетни и да имате потребне законске
			могућност приступа Веб-сајту и његовог коришћења, такође изјављујући да у потпуности
			разумете и прихватате ове услове коришћења без резерве.
		</p>
		<p>
			С друге стране, обавештавамо вас да из правних разлога архивирамо
			електронски документи у којима су куповине формализоване. Можете приступити
			ове документе у било ком тренутку тако што ћете их затражити на: {supportLink}.
		</p>
		<h3>4. УСЛОВИ КОРИШЋЕЊА САЈТА</h3>
		<p>
			Корисник је сагласан да користи веб страницу у складу са овим условима коришћења,
			важећег законодавства и добре вере. Дакле, Корисник ће одговорити на {siteName}
			и пред било којим трећим лицем за штету и губитке настале од
			коришћење супротно овим условима, законодавству и доброј вери
			од стране корисника веб странице.
		</p>
		<h3>5. ОПИС УСЛУГЕ</h3>
		<p>
			Преко услуге, {siteName} дозвољава претплату на услугу за
			изврши уређивање слика.
		</p>
		<p>
			Језик на коме је уговор између {siteName} и купца
			биће закључено да ће бити она земље порекла.<br />
			Процес куповине у онлајн сервису ће бити следећи:
		</p>
		<ol>
			<li>Морате се регистровати на веб локацији са корисничким именом и лозинком.</li>
			<li>
				Приликом регистрације корисник мора изабрати један од планова плаћања
				се налазе у одељку Цене и биће им додељени кредити у зависности од
				одабрани план. Сваки кредит ће вам омогућити да уредите једну слику.
			</li>
			<li>
				Након куповине услуге, корисник ће имати администрацију
				панел где ће пронаћи:
				<ul>
					<li>
						Одељак са листом свих слика које су обрађене, биће
						можете да га уређујете колико год пута желите и преузимате на свој
						уређај.
					</li>
					<li>
						Одељак Планови и плаћања за консултовање фактура и отказивање
						претплата.
					</li>
					<li>Одељак Мој налог да бисте могли да промените подешавања налога.</li>
				</ul>
			</li>
		</ol>
		<p>
			Када куповина услуге буде обављена, биће потврђена од
			слање е-поште, у року од максимално 24 сата, на адресу коју имате
			назначено. Назначиће услугу, како да откажете претплату, њену
			износ, примењиви порези, облик плаћања и примењиви услови и
			Услови.
		</p>
		<h4>5.1 Претплата</h4>
		<p>
			Претплата на услугу варира у зависности од изабраног плана и биће
			аутоматски се обнавља за исти временски период до његовог престанка.
			Осим ако не откажете претплату, овлашћујете нас да учитамо
			одговарајућу годишњу претплату у вашем начину плаћања.
		</p>
		<p>
			Можете да откажете своју претплату на Услугу у било ком тренутку и то ћете учинити
			имате приступ њему до краја годишњег обрачунског периода. До
			у мери дозвољеној законом, уплате су бесповратне и ми их не обезбеђујемо
			рефундације или кредити за делимичне годишње периоде претплате.
		</p>
		<h3>6. ЦЕНЕ И ПОРЕЗИ</h3>
		<p>
			Цене производа понуђених на {siteName} су наведене у еврима
			(€) или валуту земље из које је извршена куповина, вредност
			Порез на додату вредност (ПДВ) који је на снази у тренутку куповине наплаћује се на цену
			производи.
		</p>
		<p>
			У сваком случају, операција може бити ослобођена или не подложна ПДВ-у у зависности од
			своју земљу пребивалишта или стање у којем делујете. Из тог разлога,
			у неким случајевима коначна цена поруџбине може бити промењена у односу на
			један је приказан.<br />
			Куповине које су извршили субјекти ослобођени плаћања ПДВ-а ће то означити до
			слање свог ПДВ/НИФ броја путем е-поште на {supportLink}, а не евидентирање
			куповине са наведеним порезом.
		</p>
		<h3>7. НАЧИН ПЛАЋАЊА</h3>
		<p>
			Онлине плаћање купљене услуге може се извршити кредитном или дебитном картицом.
			У том смислу, {siteName} обавештава власнике кредитних и дебитних картица да
			трансакције у онлине продавници се обављају путем безбедног плаћања
			гатеваи, користећи ССЛ технологију да гарантује сигурност преноса података.
		</p>
		<h3>8. ПРАВО НА ПОВЛАЧЕЊЕ И РЕФУНДАЦИЈЕ</h3>
		<h4>8.1. Право на повлачење</h4>
		<p>
			С обзиром на врсту производа који се продаје у нашој онлајн услузи, софтвер у дигиталном облику
			формат КР, право на повлачење неће важити према
			члан 103, слово м) Краљевског законодавног декрета 1/2007, од 16. новембра, од
			да је пречишћени текст Општег закона за одбрану потрошача и
			Корисници и други комплементарни закони се одобравају.
		</p>
		<h4>8.2. Повраћај новца</h4>
		<p>
			Без обзира на план који је корисник изабрао, износе које корисник плаћа и на
			у мери која је дозвољена законом неће бити враћена.
		</p>
		<p>
			Уговорена услуга се не може уступити или пренети на друге кориснике
			Сервис.
		</p>
		<p>
			У сваком случају, корисник може користити уговорену услугу до истека
			уговорени период.
		</p>
		<h3>9. ВАЖЕНОСТ ПОНУДА</h3>
		<p>
			Услуге које се нуде у Сервису и њихове цене биће доступне за
			купују док се налазе у каталогу услуга приказаном преко овог
			веб сајт.
		</p>
		<p>
			У сваком случају, {siteName} задржава право да изврши измене
			сматра одговарајућим у Услузи, могућност ажурирања производа и услуга
			зависно од тржишта.
		</p>
		<p>
			{siteName} задржава право да промени цене без претходног обавештења. Ми
			обавештавамо вас да упркос ажурирањима цена
			Сервис, могу садржати грешке. Ми ћемо одмах исправити све грешке које
			појављују, али неће бити обавезујући за Сервис.
		</p>
		<h3>10. БЕЗБЕДНОСТ</h3>
		<p>
			Као што је горе наведено, цео поступак куповине, као и пренос
			ваших личних података и система плаћања, врши се на безбедној страници и
			на шифрован начин преко ССЛ протокола.
		</p>
		<p>
			Гарантујемо сигурност Услуге у складу са актуелним
			технолошка знања. Међутим, {siteName} не може да гарантује у потпуности
			будућу безбедност Службе. У сваком случају, обећавамо да ћемо исправити и
			спровести одговарајуће корективне мере за исправљање могућег обезбеђења
			кршење што је пре могуће.
		</p>
		<p>
			Пристајете да обавестите {siteName}, одмах и путем е-поште {supportLink}
			било које ситуације која би могла довести до лажног представљања идентитета корисника.
		</p>
		<h3>11. ИЗМЕНЕ И НИШТАВНОСТ</h3>
		<p>
			У будућности можемо такође ажурирати услове и одредбе услуге
			као карактеристике и функције саме Службе.
		</p>
		<p>
			Обавештаваћемо вас о променама услова и рокова постављањем обавештења
			на видном месту на нашој веб страници и/или путем е-поште.
		</p>
		<p>
			Ако је било која клаузула укључена у ове одредбе и услове објављена, у потпуности или
			делимично, ништав или неефикасан, то ће утицати само на поменуту одредбу или део
			од тога која је ништавна или неефикасна. Услови и одредбе ће постојати у
			све остало, имајући такву одредбу, или њен део на који утиче
			не поставља се.
		</p>
		<h3>12. ПОТРАЖИВАЊА И ТУЖБЕ ИЗ УГОВОРА</h3>
		<p>
			Колико је то могуће, ова услуга је регулисана шпанским законом.<br />
			У циљу поједностављења решавања потраживања у парничном поступку и
			смањимо трошкове, не искључујемо могућност да се подвргнемо ан
			Арбитража о правичности Арбитражног суда привредних комора и
			Индустрија. У том смислу, а према важећим прописима,
			{siteName} обавештава о постојању европског решавања спорова на мрежи
			платформа која олакшава вансудско решавање таквих спорова за
			уговори закључени и онлајн између потрошача и интернет сервиса
			провајдери. Овој платформи се може приступити преко следеће веб странице:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. ПРАВА ИНТЕЛЕКТУАЛНЕ И ИНДУСТРИЈСКЕ СВОЈИНЕ</h3>
		<p>
			Веб страница и њен садржај подлежу заштити у примени
			актуелни национални прописи о интелектуалној и/или индустријској својини, ас
			као и у примени међународних конвенција које се примењују у таквим
			стварима. {siteName} је власник или је прописно лиценцирао све
			Права интелектуалне и индустријске својине на веб страници и њен садржај.
		</p>
		<p>
			Било који облик репродукције, дистрибуције, јавне комуникације, трансформације,
			стављање на располагање и, уопште, било који други чин експлоатације без обзира да ли он или не
			у комерцијалне сврхе веб странице или њеног садржаја, без претходног
			изричити пристанак {siteName}. Изричито је забрањено брисање
			идентификујући податке {siteName} као власника интелектуалног и
			Права индустријске својине на веб страници или њен садржај.
		</p>
		<p>
			{siteName} задржава сва права интелектуалне и индустријске својине
			преко веб-сајта и његовог садржаја, такође уз задржавање било каквог правног
			радње које томе одговарају у циљу обустављања, спречавања или кривичног гоњења било којих
			незаконито коришћење веб странице или њеног садржаја. Ни у ком случају и под било
			околностима приступа веб страници или њеном коришћењу од стране корисника или треће
			стране представљају или имплицирају уступање било које врсте од стране {siteName} од
			права интелектуалне или индустријске својине веб странице или њеног садржаја.
			Ни у ком случају недостатак захтева од стране {siteName} да престане да користи
			веб локација или њен незаконит или садржај супротан овим условима може бити
			разуме се као прећутни пристанак {siteName} на такве употребе или као одрицање
			извршења било које правне радње која јој може одговарати.
		</p>

		<h3>14. ОДГОВОРНОСТИ И ГАРАНЦИЈЕ</h3>
		<p>
			Корисник мора да користи веб локацију и њен садржај у складу са
			одредбама ових услова коришћења, важећег законодавства и добре вере. Било која
			употреба веб странице или њеног садржаја супротно овим општим условима,
			закону или доброј вери је изричито забрањена, без обзира на то да ли је поменута употреба имала
			економску сврху или не.<br />
			Корисник ће бити одговоран за било какву штету или губитке проузроковане {siteName}
			или трећим лицима која директно или индиректно произилазе из било какве употребе
			коју Корисник чини на веб локацији или њеном садржају у супротности са овим
			условима, законом, моралом, јавним редом или добром вером.
		</p>
		<p>
			Да би веб локација и њен садржај били доступни кориснику, {siteName}
			захтева услуге које пружају трећа лица. Могуће је да
			упркос напорима које {siteName} улаже да веб-сајт остане доступан
			и доступан корисницима, његова доступност може бити суспендована, прекинута или
			отказана из разлога изван {siteName}. Зато {siteName}
			не гарантује одсуство прекида или грешака у приступу
			веб-сајту или његовом садржају, нити да се ажурирају или увек приказују у
			њихову најновију верзију. Сходно томе, {siteName} одбија било какву
			одговорност за штету која може настати кориснику или трећим лицима као
			резултат обуставе, прекида, недостатка континуитета, прекида мреже
			или прекида везе са веб-сајтом.
		</p>
		<p>
			Ни у ком случају и ни под којим околностима {siteName} неће бити одговоран за
			штете или губитке настале кориснику из разлога који се не могу приписати {siteName},
			као што су, као пример и ни у ком случају ограничавајући, природне
			катастрофе, ситуације више силе или екстремне хитности, вируси, штетне
			компоненте, кварови у претраживачу, пад мреже, упади у рачунар или
			напади трећих страна.
		</p>

		<h3>15. ЛИНКОВИ</h3>
		<p>
			Веб локације, платформе, форуми, ћаскање, блогови или спољне друштвене мреже које
			линкују или повезују на веб локацију морају јасно да обавесте да немају
			овлашћење или надзор {siteName} и наведено повезивање или
			веза не подразумева, претпоставља или имплицира везу било које врсте између {siteName}
			и веб-сајтова, платформи, форума, ћаскања, блогова или екстерних
			друштвених мрежа које повезују или линкују на веб локацију.
		</p>
		<p>
			У сваком случају, свака веза која је намењена веб локацији мора бити усмерена
			директно на почетну страницу или почетну страницу веб странице кликом на УРЛ
			веб локације која покрива цео екран почетне странице или странице на почетку
			веб-сајта, тако да је веза апсолутна и потпуна без употребе
			оквира, фрамова или хипервеза. {siteName} ни у ком случају не одговара
			и под било којим околностима на садржај, информације или податке који се односе на
			веб-сајт, његов садржај или било које друго питање садржано на веб-сајтовима, платформама,
			форумима, ћаскањима, блоговима или друштвеним мрежама трећих страна које повезују или повезују на
			веб-сајт.
		</p>
		<p>
			Изричито је забрањено повезивати или линковати веб локацију са веб локацијама,
			платформама, форумима, ћаскањима, блоговима или друштвеним мрежама супротно закону, моралу
			и добрим обичајима, посебно оним са порнографским, недозвољеним, илегалним или
			садржајем који крши људска права.
		</p>
		<p>
			С друге стране, веб локација може садржати везе ка веб локацијама трећих страна,
			платформама, форумима, ћаскањима, блоговима или друштвеним мрежама. {siteName} не
			имају људска и/или техничка средства да знају или контролишу информације и
			садржај који се појављује на веб локацијама трећих страна. Стога, ни у ком случају {siteName}
			неће бити одговоран за садржај повезаних сајтова и под
			било којим околностима не могу се сматрати да имају ефективно познавање садржаја
			сајтова на које повезују.
		</p>

		<h3>16. ЗАШТИТА ПОДАТАКА</h3>
		<p>
			Као што је утврђено у свом {privacyPolicyLink}, {siteName} се обавезује да ће користити корисника
			податке, да поштује њихову поверљивост и да их користи у складу са
			сврхом третмана, као и да испоштује своју обавезу да га сачува
			и прилагоди све мере како бисте избегли измене, губитак, третман или неовлашћено
			приступ у складу са одредбама важећег законодавства у вези са
			заштитом личних података.
		</p>
		<p>
			Веб страница укључује одговарајуће мере заштите и користи индустријски стандард
			технологија за побољшање безбедности, интегритета, потпуности, тачности и
			заштиту личних података које је прикупио и успоставио
			разумне мере предострожности за заштиту тих информација од могућег губитка или
			злоупотребе. Њена правила о заштити и безбедности података се периодично ревидирају
			и побољшавају када је то потребно, а настоји да обезбеди да само овлашћени
			лица могу приступити информацијама које је дао Корисник.
		</p>
		<p>
			Да бисте сазнали више о управљању и лечењу које спроводи {siteName}
			ваших података, прочитајте наше {privacyPolicyLink} и {cookiesPolicyLink}.
		</p>
		<h3>17. ТРАЈАЊЕ И ИЗМЕНЕ</h3>
		<p>
			Ови услови коришћења ће бити на снази све док су им изложени
			корисници, тако да чим буду потпуно или делимично модификовани или ажурирани,
			ови услови ће престати да важе, будући да су нови услови коришћења
			они који даље регулишу коришћење веб странице.
		</p>
		<p>
			{siteName} задржава право да их прегледа, измени или ажурира
			услове коришћења у било ком тренутку. У случају било какве промене ових услова
			употребе из било ког разлога, {siteName} ће обавестити кориснике на почетној страници о
			вебу о наведеној околности како би били прописно обавештени и могли да се консултују
			ревизије, модификације или ажурирања садашњих услова коришћења за
			ваше задовољство.
		</p>
		<h3>18. ОПШТИ</h3>
		<p>
			Ни у ком случају и ни под којим околностима не може доћи до неостваривања ваших права
			од стране {siteName} схватити као одрицање од њих.
		</p>
		<p>
			Наслови садржани у овим условима су само индикативни или
			информативни, тако да не утичу, не квалификују или проширују тумачење
			од тога.
		</p>
		<p>
			У случају да је било која од клаузула садржаних у овим условима била
			проглашена ништавном, увредљивом или неприменљивом, потпуно или делимично, од стране суда
			или административног органа, наведена изјава ће појединачно утицати на клаузулу
			у питању, узимајући га као не и без проглашења ништавости, злоупотребе или
			неприменљивости се под било којим околностима проширује на остатак
			услове, који ће опстати.
		</p>
		<p>
			Ови услови коришћења, као и {privacyPolicyLink} и {cookiesPolicyLink}
			у сваком тренутку су регулисани важећим шпанским прописима.
		</p>
		<h3>19. КОРИСНИЧКИ СЕРВИС</h3>
		<p>
			За било какво појашњење, инцидент или захтев, можете нас контактирати путем:<br />
			Е-пошта: {supportLink}<br />
			Поштанска адреса: Ав. Церданиола, 75 - 1º, ЦП 08172, Сант Цугат дел Валлес, Барселона, Шпанија.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Последње ажурирање: 10. јуна 2024',
		content: `
			<h3>1. Одговорна страна и опис</h3>
			<h5>1.1. Одговоран</h5>
			<p>
				Особа одговорна за третман овог сајта је Ремове Бацкгроунд С.Л (у даљем тексту Ремове Бацкгроунд). 
				или Службе), са адресом на адреси Ав. Церданиола, 75 - 1º, ЦП 08172, Сант Цугат дел Валлес, Барселона, Шпанија.
			</p>
			<p>
				НИФ: Б56768260<br />
				Е-пошта: {supportLink}
			</p>
			
			<h5>1.2. Опис</h5>
			<p>
				Прихватање {privacyPolicyLink} за уклањање позадине (у даљем тексту „Политика приватности“) је неопходан услов 
				за коришћење наше веб странице и пружање услуге (у даљем тексту „Услуга“).<br />
				Ова Политика приватности регулише прикупљање, третман и коришћење ваших личних и неличних података 
				као корисник Уклони позадину, од датума ступања на снагу који се појављује у заглављу.<br />
				За обраду ваших личних података, Ремове Бацкгроунд је у складу са актуелним локалним и европским законодавством, 
				као и његовим проведбеним прописима.
			</p>
			
			<h3>2. Прикупљене информације</h3>
			<p>
				Приступ нашој веб страници може се обавити без потребе за давањем било каквих информација, иако се региструјете и / 
				или уговорите наше планове, мораћете да нам дате неке личне податке. Информације (личне 
				или неличне) које прикупља Услуга могу да варирају у зависности од тога.<br />
				Личне и неличне информације које прикупља Услуга ће доћи до нас на три начина: 1) оне које 
				се аутоматски прикупљају 2) оно што нам добровољно доставите и 3) оно што нам обезбеде трећа лица.
			</p>
		

			<h5>2.1. Онај који се прикупља аутоматски</h5>
			
			<p>Ове информације ће се састојати од:</p>

			<ul>
				<li>Онај који се прикупља путем колачића или сличних механизама који се чувају на вашем уређају, увек уз вашу сагласност или у 
					у складу са другим правним основама. Погледајте нашу политику колачића за више информација.</li>
				<li>ИП адреса са које се успоставља веза, тип уређаја који се користи и његове карактеристике, верзија 
					оперативни систем, тип претраживача, језик, датум, држава, време захтева, 
					УРЛ адресу са које долазите, УРЛ адресу на коју идете или мобилну мрежу која се користи, између осталог.</li>
				<li>Подаци о коришћењу услуге и могуће грешке откривене током њеног коришћења.</li>
				<li>Поред тога, Ремове Бацкгроунд користи Гоогле аналитику, аналитичку услугу коју пружа Гоогле, ЛЛЦ. 
					са седиштем у Сједињеним Државама са седиштем на адреси 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					За пружање ових услуга користе колачиће који прикупљају информације, укључујући ИП адресу корисника, 
					које ће Гоогле преносити, обрађивати и чувати под условима утврђеним на веб страници www.google.com. 
					Укључујући могући пренос наведених информација трећим лицима из разлога законских захтева или 
					када наведене треће стране обрађују информације у име Гоогле-а.</li>
			</ul>

			<p>У сваком случају, можете да онемогућите колачиће Гоогле Аналитике <a href="{externalLink: disableGoogleAnalyticsLink}">овде</a>.</p>

			<h5>2.2. Онај који добровољно дате</h5>

			<p>Ове информације ће се састојати од:</p>

			<ul>
				<li>Сви подаци су обавезни.</li>
				<li>Онај који је потребан за уклањање позадине да заврши регистрацију на вебу: име и презиме, адреса и е-пошта, између осталог.</li>
				<li>Сви подаци су обавезни.</li>
				<li>Информације, личне или не, за завршетак уговарања услуге, као што су ваша адреса е-поште и број ваше кредитне или дебитне картице.</li>
				<li>Информације, личне или не, које поруке послате путем контаката или канала мишљења успостављених у Сервису могу садржати, на пример ваше име и имејл.</li>
			</ul>

			<h5>2.3. Онај који пружају трећа лица</h5>
			<p>Ове информације ће се састојати од:</p>
			<ul>
				<li>Онај који пружају системи плаћања или процесори кредитних картица, као што је време куповине или њен износ.</li>
			</ul>

			<h3>3. Права и сврхе</h3>
			<p>
				Обавјештавамо вас да је попуњавање образаца добровољно. Међутим, ако не попуните обавезна поља 
				(обично означено звездицом), коришћење неких функција Услуге неће бити могуће или ће бити ограничено.<br />
				Лични подаци које нам доставите биће укључени и обрађени у Регистар активности третмана за уклањање позадине 
				како бисмо могли да одговоримо на ваше захтеве, пружимо тражену услугу и обавештавамо вас о стварима у вези са активношћу 
				компаније и њених услуга.<br />
				У сваком тренутку можете остварити права на приступ, исправљање, брисање, ограничење вашег третмана, 
				противљење и преносивост ваших личних података путем е-поште на адресу: {supportLink} или на поштанску адресу: 
				Ав. Церданиола, 75 - 1º, ЦП 08172, Сант Цугат дел Валлес, Барселона, Шпанија.<br />
				У оба случаја, морате да се идентификујете својим именом и презименом, као и копијом ДНИ или националне личне карте, ако је потребно.<br />
				У случају да сте дали сагласност за одређену сврху, имате право да повучете сагласност у било ком тренутку, 
				без утицаја на законитост третмана на основу пристанка пре његовог повлачења.<br />
				Поред тога, ако сматрате да постоји проблем са начином на који Уклони позадину рукује вашим подацима, 
				своје жалбе можете упутити <a href="{knowYourRightsLink}">органу за заштиту података</a> који одговара, будући да је <a href="{aepdLink}">Шпанска агенција за заштиту података</a> 
				онај наведен у случају Шпаније.
			</p>

			<h3>4. Старост</h3>
			<p>Што се тиче коришћења онлајн услуге, изјављујете да сте пунолетни и да имате неопходне законске 
				способности да будете везани овим уговором и да користите сајт у складу са његовим одредбама и условима, које сте у потпуности 
				разумели и признали.<br />
				Изјављујете да су све информације које дајете за приступ Услузи, пре и током њеног коришћења, истините, потпуне 
				и тачне.</p>

			<h3>5. Коришћење података</h3>
			<p>Уклони позадину ће користити прикупљене податке за:</p>
			<ul>
				<li>Управљање Услугом и ажурирање (правни основ је наш легитимни интерес за одржавање и одржавање Услуге 
					ажуриране и у добром стању).</li>
				<li>Одговор на питања која постављате (правни основ је наш легитимни интерес да одговоримо на захтеве и 
					недоумице наших корисника).</li>
				<li>Обрада уплата које извршите (уговор је правни основ).</li>
				<li>Пружање уговорене услуге (уговор је правни основ).</li>
				<li>Одржавање безбедности Услуге, истраживање незаконитих активности, спровођење наших услова и одредби и
					помоћ државним снагама безбедности у оквиру њихових могућих истрага (правни основ је наш 
					легитимни интерес за гарантовање и одржавање безбедности Услуге и њених корисника).</li>
			</ul>
			<p>Уклони позадину не користи аутоматизоване одлуке, иако може да генерише основне корисничке профиле, 
				правни основ је наш легитимни интерес у комерцијалне сврхе и пружање персонализованих понуда.<br />
				Такође, Уклони позадину може да користи корисничке информације у облику збирних и анонимних података да их прикаже трећим лицима. 
				Такође можете да делите статистичке и демографске информације о корисницима и њиховом коришћењу Услуге са трећим лицима. 
				Али ништа од овога неће омогућити тим трећим странама да вас лично идентификују.</p>

			<h5>5.1. У имејловима и обрасцима за контакт</h5>
			<p>Веб локација има SSL енкрипцију која омогућава кориснику да безбедно пошаље своје личне податке путем стандардних образаца за контакт.<br />
				Прикупљени лични подаци биће предмет аутоматизоване обраде и уграђени у одговарајуће датотеке 
				записа о активностима обраде и чији је власник Уклони позадину.</p>
			<p>У том смислу:</p>
			<ul>
				<li>Примићемо вашу IP адресу, која ће се користити за проверу порекла поруке како бисмо вам понудили адекватну 
					препоруку (на пример, представите информације на исправном језику) и да откријемо могуће неправилности 
					(на пример, могући покушаји сајбер напада на Услугу), као и податке у вези са вашим ИСП-ом.</li>
				<li>Слично, можете нам доставити своје податке телефоном, имејлом и другим назначеним средствима комуникације.</li>
			</ul>
			<p>У вези са коришћеним средствима плаћања:</p>
			<ul>
				<li>Наши провајдери платних услуга који плаћају за пружање наших услуга су кредитне или дебитне картице. 
					Ни у једном тренутку Услуга или њено особље неће имати приступ банковним детаљима (на пример, број кредитне картице) 
					које ће корисник као купац пружити тим трећим лицима.</li>
			</ul>

			<h3>6. Задржавање података</h3>
			<p>У наставку су назначени колико дуго се чувају подаци које обрађује Услуга:</p>
			<ul>
				<li>Дезагрегирани подаци ће се чувати без периода брисања.</li>
				<li>
					Подаци о клијентима ће се чувати минимално потребно и могу се чувати до:
					<ul>
						<li>5 година, према чл. 1964. Грађанског законика (личне радње без посебног рока).</li>
						<li>6 година, према чл. 30 Трговинског законика (на пример, књиговодствене књиге или фактуре).</li>
					</ul>
				</li>
				<li>Подаци корисника ће се чувати највише 12 месеци да би могли да се удовоље њиховим захтевима.</li>
			</ul>

			<h3>7. Подаци који се деле са трећим лицима</h3>
			<p>Постоје треће стране које управљају делом услуге.<br />
				Уклањање позадине захтева од њих да се придржавају ове Политике приватности када је применљиво, поред тога што имају сопствену. Међутим, Уклони позадину неће бити одговоран за усклађеност са наведеним смерницама.<br />
				У неким околностима, Уклони позадину може да дели, користи или сачува са трећим странама било који од прикупљених личних података:</p>
			<ul>
				<li>Да бисте пружили услугу:</li>
			</ul>
			<p>Добављачи услуга који обављају функције у наше име, као што су услуге плаћања, веб хостинг, пословна аналитика, корисничка подршка или веб маркетинг. Ови провајдери услуга могу прикупљати и имати приступ информацијама које су им неопходне за обављање њихових функција, али им није дозвољено да деле или користе информације у било коју другу сврху.</p>
			<ul>
				<li>За сарадњу са надлежним органима:</li>
			</ul>
			<p>Ако сматрамо да је разумно неопходно да се задовољи било који закон, правни процес или легитимни интерес. У сваком случају, даћемо само оне информације које су стриктно потребне.</p>

			<h3>8. Мере безбедности</h3>
			<p>Уклони позадину усваја све техничке и организационе мере неопходне за
				заштиту безбедности и интегритета прикупљених личних и неличних података. 
				И против неовлашћеног приступа и његове случајне измене, губитка или уништења.<br />
				У сваком случају, Уклони позадину не може гарантовати апсолутну сигурност прикупљених информација, 
				тако да морате да сарађујете и користите здрав разум о информацијама које се деле у сваком тренутку.<br />
				Разумете и прихватате да, чак и након брисања, личне и неличне информације могу 
				остати видљиве у кешу или ако су их други корисници копирали или сачували.</p>

			<h3>9. Промене Политике приватности</h3>
			<p>Можда ћемо ажурирати ову Политику приватности у будућности. Обавестићемо вас о њеним променама слањем обавештења на наведену адресу е-поште и/или постављањем обавештења на видно место на нашој веб страници.</p>

			<h3>10. Контакт</h3>
			<p>Ако имате питања о овој политици приватности, контактирајте нас на:</p>
			<p>Е-пошта: {supportLink}<br /> 
				Адреса: Ав. Церданиола, 75 - 1º, ЦП 08172, Сант Цугат дел Валлес, Барселона, Шпанија.</p>`
	},
	gdpr: {
		lastUpdate: 'Последње ажурирање: 10. јуна 2024',
		content: `
			<h3>1. Ко је одговоран и како их контактирати?</h3>
			<p>Контролер овог сајта је Ремове Бацкгроунд С.Л са адресом на адреси Ав. Церданиола, 75 - 1º, ЦП 08172, Сант Цугат дел Валлес, Барселона, Шпанија.</p>
			<p>Можете да га контактирате путем е-поште на {supportLink}.</p>
			
			<h3>2. Који подаци се прикупљају?</h3>
			<p>
				Аутоматски прикупљамо податке путем колачића које учитавамо на ваш уређај, укључујући аналитику. 
				Такође прикупљамо ИП са којег се успоставља веза, тип уређаја који се користи и његове карактеристике, 
				верзија оперативног система, тип претраживача, језик, датум, држава, време захтева, 
				УРЛ са којег долазите, УРЛ на који идете или мобилну мрежу која се користи, између осталог.<br>
				Корисник нам добровољно даје неке податке као што су његово име и презиме, е-маил или банковни подаци 
				да бисте могли да нас контактирате, пријавите се за услугу или купите претплату.
			</p>
			
			<h3>3. За шта се користе прикупљени подаци?</h3>
			<p>
				Услуга ће користити прикупљене податке, између осталог, за администрирање и ажурирање услуге, одговарање на ваше захтеве, 
				слати вам наш билтен и промотивне понуде путем е-поште, управљати регистрацијом на платформи, управљати и пружати 
				услуге које се односе на вашу претплату, обраду плаћања која вршите и издавање одговарајућих фактура, 
				одржава безбедност Услуге, истражује незаконите активности, спроводи наше услове и одредбе и 
				pомоћи снагама и органима државне безбедности у оквиру њихових евентуалних истрага.
			</p>
		

			<h3>4. Колико дуго се чувају?</h3>
			<ul>
				<li>Дезагрегирани подаци ће се чувати без периода брисања.</li>
				<li>
					Подаци о клијентима ће се чувати минимално потребно и могу се чувати до:
					<ul>
						<li>5 година, према чл. 1964. Грађанског законика (личне радње без посебног рока).</li>
						<li>6 година, према чл. 30. Привредног законика (на пример, књиговодствене књиге или фактуре).</li>
					</ul>
				</li>
				<li>Подаци корисника ће се чувати највише 12 месеци како би се испунили њихови захтеви.</li>
				<li>Кориснички подаци које је Услуга отпремила на странице и профиле на друштвеним мрежама чуваће се од тренутка када корисник да своју сагласност док је не повуче.</li>
			</ul>


			<h3>5. Која су ваша права као корисника?</h3>

			<p>
				Право приступа: Захваћена страна има право да добије потврду од контролора података о томе да ли 
				или се не обрађују лични подаци који се односе на њега или њу.
			</p>
			<p>
				Право на исправку: погођена страна има право да добије, без непотребног одлагања, од контролора података 
				исправку личних података који су нетачни и који директно утичу на њега. Исто тако, заинтересована страна ће 
				имати право да допуне непотпуне личне податке, укључујући и путем додатне изјаве.
			</p>
			<p>
				Право на брисање: Право је погођене стране да добије, без непотребног одлагања, од контролора података брисање 
				личних података који га се тичу.
			</p>
			<p>
				Право на ограничење обраде података: састоји се у добијању ограничења обраде ваших података од стране одговорне особе, 
				иако његова примена има два аспекта: 1) Када оспорите тачност ваших личних података, током периода који дозвољава 
				одговорно лице да то провери и 2) Када сте уложили приговор на обраду ваших личних података да је одговорно лице 
				врши на основу легитимног интереса или мисије од јавног интереса, док одговорно лице проверава да ли ови разлози 
				превладати над твојим.
			</p>
			<p>
				Право на преносивост података: Право је погођене стране да добије личне податке који се на њега односе, 
				које је дао контролору података, у структурираном формату, за уобичајену употребу и механичко очитавање, и 
				да их пренесе другом контролору а да их не спречи контролор коме су достављене.
			</p>
			<p>
				У том смислу, заинтересована страна ће имати право да се лични подаци преносе директно од руковаоца 
				контролору када је то технички могуће.
			</p>


			<h3>6. Како можете остварити своја права?</h3>

			<p>
				Своја права на личне податке можете остварити у било ком тренутку слањем е-поште на: {supportLink} или на поштанску адресу: 
				Ав. Церданиола, 75 - 1º, ЦП 08172, Сант Цугат дел Валлес, Барселона, Шпанија. У оба случаја морате се идентификовати својим именом и презименом, 
				као и копију вашег ДНИ или националне личне карте, ако је потребно.<br>
				Поред тога, ако сматрате да постоји проблем са начином на који Уклони позадину рукује вашим подацима, можете упутити своје захтеве 
				<a href="{knowYourRightsLink}">органу за заштиту података</a> који одговара, будући да је <a href="{aepdLink}">Шпанска агенција за заштиту података</a> 
				онај наведен у случају Шпаније.
			</p>

			<h3>7. Да ли су усвојене мере безбедности?</h3>
			<p>
				Служба предузима све неопходне техничке и организационе мере ради заштите безбедности и интегритета личности 
				и прикупљене неличне информације. И против неовлашћеног приступа и случајне измене, губитка или уништења.<br>
				У сваком случају, Услуга не може гарантовати апсолутну сигурност прикупљених информација, тако да морате сарађивати и 
				увек користите здрав разум у вези са дељеним информацијама.<br>
				Разумете и прихватате да, чак и након брисања, личне и неличне информације могу остати видљиве у кешу или 
				ако је копирају или чувају други корисници.
			</p>

			<h3>8. Да ли постоје трансфери личних података или међународни трансфери?</h3>

			<p>
				Не преносимо податке нити међународне трансфере. Међутим, постоје трећа лица која управљају делом услуге 
				да захтевамо да се придржавамо наше Политике приватности у оној мери у којој је она применљива на њих и да они имају сопствену. 
				Ове треће стране су добављачи услуга који обављају функције у наше име, као што су веб хостинг, 
				праћење аналитике или веб развој.<br>
				Такође, ако сматрамо да је разумно неопходно да се задовољи било који закон, правни процес или легитимни интерес. 
				У сваком случају, ми ћемо дати само стриктно потребне информације.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Последње ажурирање: 21. јуна 2024',
		content: `
			<h3>Резиме</h3>
			<ul>
				<li>Коришћени колачићи: <strong>Сопствени и трећи</strong></li>
				<li>Да ли се користе за добијање статистике? <strong>Да, на основу нашег легитимног интереса за боље управљање услугом.</strong></li>
				<li>Услуге трећих страна које инсталирају колачиће преко овог веб-сајта: <strong>Гоогле, Гоогле аналитика, Цлоудфларе и Стрипе.</strong></li>
			</ul>
			
			<h3>Како да конфигуришете и онемогућите колачиће</h3>
			<p>
				Можете дозволити, блокирати или избрисати колачиће инсталиране на вашем уређају из вашег веб претраживача. Ако не дозволите да се колачићи инсталирају на ваш уређај, 
				искључење колачића може погоршати искуство прегледања. У наставку можете пронаћи како да конфигуришете колачиће у сваком прегледачу:
			</p>
			<ul>
				<li><a href="{externalLink: edgeCookies}">Едге</a></li>
				<li><a href="{externalLink: chromeCookies}">Гоогле Цхроме</a></li>
				<li><a href="{externalLink: googleAndroidCookies}">Гоогле Андроид</a></li>
				<li><a href="{externalLink: internetExplorer8Cookies}">Интернет Екплорер 8</a></li>
				<li><a href="{externalLink: internetExplorer9Cookies}">Интернет Екплорер 9</a></li>
				<li><a href="{externalLink: internetExplorer11Cookies}">Интернет Екплорер 11</a></li>
				<li><a href="{externalLink: firefoxCookies}">Мозилла Фирефок</a></li>
				<li><a href="{externalLink: operaCookies}">Опера</a></li>
				<li><a href="{externalLink: safariCookies}">Сафари</a></li>
				<li><a href="{externalLink: safariMobileCookies}">Сафари Мобиле</a></li>
			</ul>		

			<h3>1. Врсте и употреба</h3>
			<p>Услуга користи сопствене колачиће и колачиће треће стране за побољшање прегледања, пружање услуге и добијање статистике о коришћењу веб-сајта.</p>

			<h3>2. Шта је колачић и за шта се користи?</h3>
			<p>
				Колачић је текстуална датотека која се шаље на ваш рачунар, мобилни или таблет веб прегледач и користи се за чување и преузимање информација о
				прегледање је завршено. На пример, да запамтите своје корисничко име и лозинку или подешавања вашег профила.
			</p>

			<h3>3. Које врсте колачића постоје?</h3>
			<p>Према томе ко њима управља:</p>
			<ul>
				<li>Сопствени колачићи; шаљу се вашем претраживачу са наше опреме или веб домена.</li>
				<li>Колачићи треће стране; шаљу се вашем прегледачу са опреме или веб домена којима ми не управљамо директно, већ трећи ентитет као што је Гоогле.</li>
			</ul>
			<p>На основу тога колико дуго остају активни, постоје:</p>
			<ul>
				<li>Колачићи сесије; они остају у датотеци колачића вашег претраживача док не напустите веб локацију, тако да ниједан не остаје на вашем уређају.</li>
				<li>Трајни колачићи; они остају на вашем уређају и наша веб локација их чита сваки пут када направите нову посету. Ови колачићи престају да раде након одређеног датума.</li>
			</ul>

			<p>Коначно, према њиховој намени, имамо:</p>
			<ul>
				<li>Технички колачићи; побољшавају прегледање и правилно функционисање веб странице.</li>
				<li>Колачићи за персонализацију; омогућавају приступ сервису са унапред дефинисаним карактеристикама на основу низа критеријума.</li>
				<li>Колачићи за аналитику; омогућавају мерење и статистичку анализу коришћења пружене услуге.</li>
			</ul>
			<p>Листа колачића трећих страна које користи <strong>remove-background.com</strong></p>
			<ul>
				<li>
					<a href="{externalLink: googleCookiesPolicy}">Гоогле</a>: Њихови колачићи (НИД или ЦОНСЕНТ) омогућавају персонализовање начина на који се огласи приказују ван Гоогле-а или чување информација
					као што је жељени језик када се приказују резултати претраге.<br><a href="{externalLink: googleCookieTypes}">Више информација</a> о типовима колачића које Гоогле користи у својим различитим услугама.
				</li>
				<li>
					<a href="{externalLink: googleAnalyticsCookies}">Гоогле аналитика</a>: Њихови колачићи (као што је _га) омогућавају пребројавање колико пута корисник посети веб локацију, како, када и одакле.<br>
					У сваком случају, можете да онемогућите колачиће Гоогле аналитике <a href="{externalLink: disableGoogleAnalytics}">овде</a>.
				</li>
				<li>Цлоудфларе: Да бисте сазнали више о Цлоудфларе политици колачића и коришћењу, кликните на <a href="{externalLink: cloudflareCookiesPolicy}">овај линк</a>.</li>
				<li>Стрипе: Пронађите информације <a href="{externalLink: stripeCookiesPolicy}">овде</a> о Стрипе-овим смерницама и коришћењу колачића.</li>
			</ul>
		`
	}
};
